import ArrayProxy from "@ember/array/proxy"
import { computed } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import { extractCardStackTemplateIds } from "cc-frontend/utils/filter-dates/course"
import { includes } from "lodash-es"
import styles from "./course-pill.module.css"
const ArrayPromiseProxy = ArrayProxy.extend(PromiseProxyMixin)

interface Args {
  course: Course
  cardStackTemplateId: string
  toggleTemplateForCourse: Function
}

export default class CoursePillComponent extends Component<Args> {
  readonly styles = styles

  @computed("args.course.attributes.calendar.version", "args.cardStackTemplateId")
  get isSelected() {
    return includes(extractCardStackTemplateIds(this.args.course), this.args.cardStackTemplateId)
  }
}
